import { Link } from "react-router-dom";
import { Phone, MessageSquareText } from "lucide-react";
import { COMPANY } from "../../data/content";

export const FloatingCTA = () => (
  <div className="fixed bottom-4 inset-x-4 z-40 flex gap-3 lg:hidden" data-testid="floating-cta">
    <a
      href={COMPANY.phoneHref}
      data-testid="floating-call"
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-sm bg-sml-forest text-white font-medium py-3.5 shadow-lg shadow-sml-forest/30 active:scale-[0.98] transition-transform"
    >
      <Phone className="h-4 w-4" /> Call {COMPANY.phone}
    </a>
    <Link
      to="/contact"
      data-testid="floating-enquire"
      className="inline-flex items-center justify-center gap-2 rounded-sm bg-sml-bronze text-sml-forest font-semibold px-5 py-3.5 shadow-lg active:scale-[0.98] transition-transform"
    >
      <MessageSquareText className="h-4 w-4" /> Enquire
    </Link>
  </div>
);
